import * as yup from "yup";

import validateFormatNationalCode from "../../../../function/validateFormatNationalCode";

const formAgentYupResolver = (personType, areas) => {
  yup.addMethod(yup.string, "nationalCodeFormat", function (errorMessage) {
    return this.test(`test-card-length`, errorMessage, function (value) {
      const { path, createError } = this;

      return (
        validateFormatNationalCode(value) ||
        createError({ path, message: errorMessage })
      );
    });
  });

  const nationalCodeValidation =
    personType === 0
      ? yup
          .string()
          .required("کد ملی الزامی")
          .length(10, "باید 10 رقم باشد")
          .nationalCodeFormat("فرمت کد ملی باید رعایت شود")
      : yup
          .string()
          .required("شناسه ملی شرکت الزامی")
          .length(11, "باید 11 رقم باشد");

  const schema = yup.object({
    name: yup.string().required("نام الزامی"),
    family:
      personType === 0 ? yup.string().required("نام خانوادگی الزامی") : null,
    nationalCode: nationalCodeValidation,
    registrNumber:
      personType === 1 ? yup.string().required("شماره ثبت الزامی") : null,
    phone: yup
      .string()
      .required("موبایل الزامی")
      .length(11, "باید 11 رقم باشد"),
    email: yup.string().email("باید فرمت صحیح ایمیل باشد"),
    password: yup
      .string()
      .required("رمز الزامی")
      .min(8, "باید حداقل 8 کاراکتر باشد"),
    confirmPassword: yup
      .string()
      .required("رمز الزامی")
      .oneOf([yup.ref("password")], "رمز ها با هم یکسان نیستند"),

    province: yup.number().required().min(1, "استان الزامی"),
    city: yup.number().required().min(1, "شهر الزامی"),
    address: yup.string().required("ادرس الزامی"),
    tel: yup.string().required("تفن الزامی"),
    major: yup.string().required("رشته تحصیلی الزامی"),
    postCode: yup
      .string()
      .required("کد پستی الزامی")
      .length(10, "باید 10 رقم باشد"),

    area: yup.number().min(areas.length === 0 ? 0 : 1, "منطقه الزامی"),

    managerName:
      personType === 1 ? yup.string().required("نام مدیر عامل الزامی") : null,
    managerFamily:
      personType === 1
        ? yup.string().required("نام خانوادگی مدیر عامل الزامی")
        : null,
    managerNationalCode:
      personType === 1
        ? yup
            .string()
            .required("کد ملی مدیر عامل الزامی")
            .length(10, "باید 10 رقم باشد")
            .nationalCodeFormat("فرمت کد ملی باید رعایت شود")
        : null,

    birthDay: yup.string().required("تاریخ تولد الزامی"),
  });

  return schema;
};

export default formAgentYupResolver;
